import { render, staticRenderFns } from "./AdminPendingApprovalList.vue?vue&type=template&id=bc040ae0&lang=pug&"
import script from "./AdminPendingApprovalList.vue?vue&type=script&lang=js&"
export * from "./AdminPendingApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./AdminPendingApprovalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports